export default __webpack_public_path__ + "static/media/icon_10.20cba570.png";